module.exports = __webpack_public_path__ + "static/media/BBQ_salad.535d87cd.png";